module.exports = __webpack_public_path__ + "img/level_one_hover.954931a4.png";